import { getStatus, isStatus } from '@/utils'
import { STATEMENT_STATUSES } from '../constants'
import type { Statement, StatementStatus, StatementStatusKey } from '../stores'

const SET_ASIDE_KIND = 'not_a_statement'

const isSetAsideKind = (kind: string | null | undefined) =>
  kind?.toLowerCase() === SET_ASIDE_KIND

export const isStatementProcessing = (statement: Statement) =>
  isStatementStatus(
    statement,
    'segmenting',
    'recognizing',
    'extracting',
    'categorizing',
    'enqueued',
  )

export const isStatementDuplicated = (statement: Statement) =>
  isStatementStatus(statement, 'duplicated')

export const isStatementNotDuplicated = (statement: Statement) =>
  !isStatementDuplicated(statement)

// Check-image uploads have their own Statement row but are not bank/credit-card
// statements; they belong in the Checks view, not the Statements grid or
// coverage chart.
export const isChecksStatement = (statement: Statement) =>
  statement.kind === 'checks'

export const isBankishStatement = (statement: Statement) =>
  !isChecksStatement(statement)

// Set aside on purpose: no transactions were loaded and there is nothing to reconcile. The document
// still belongs in the Files grid, so this only keeps it out of the reconcile surfaces.
export const isSetAsideStatement = (statement: Statement) =>
  isSetAsideKind(statement.kind)

export const isStatementToStart = (statement: Statement) =>
  isStatementStatus(statement, 'notStarted', 'failed')

export const hasStatementFailed = (statement: Statement) =>
  isStatementStatus(statement, 'failed')

export const isStatementStatus = (
  statement: Statement,
  ...expectations: StatementStatusKey[]
) => isStatus(STATEMENT_STATUSES, statement, 'status', ...expectations)

export const getStatementStatus = (value: StatementStatus) =>
  getStatus(STATEMENT_STATUSES, value)
